var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgIcStarFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.22131 30.8883C8.44931 31.2843 7.57331 30.5903 7.72931 29.7023V29.7063L9.38931 20.2463L2.34331 13.5343C1.68531 12.9063 2.02731 11.7583 2.90931 11.6343L12.7053 10.2423L17.0733 1.58629C17.1565 1.41087 17.2878 1.26265 17.4519 1.15887C17.616 1.05509 17.8062 1 18.0003 1C18.1945 1 18.3846 1.05509 18.5487 1.15887C18.7128 1.26265 18.8441 1.41087 18.9273 1.58629L23.2953 10.2403L33.0913 11.6323C33.9753 11.7563 34.3153 12.9043 33.6553 13.5323L26.6113 20.2443L28.2713 29.7043C28.4273 30.5903 27.5513 31.2843 26.7793 30.8883L18.0013 26.3763L9.22131 30.8883Z",
    fill: "url(#paint0_linear_2126_2428)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2126_2428",
    x1: 2,
    y1: 16.0011,
    x2: 34.0006,
    y2: 16.0011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F46E0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5A266"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStarFilled);
export default __webpack_public_path__ + "static/media/ic-star-filled.2f50a16322400fb992d83b6bafdd5c29.svg";
export { ForwardRef as ReactComponent };